
import { Instagram, Twitter, Linkedin } from "lucide-react";
import TikTokIcon from "./icons/TikTokIcon";

interface SocialLinkProps {
  href: string;
  icon: React.ReactNode;
  label: string;
}

const SocialLink = ({ href, icon, label }: SocialLinkProps) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="p-2 rounded-full transition-colors duration-300 hover:text-primary/80 hover:scale-110 transform"
    aria-label={label}
  >
    {icon}
  </a>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full py-8 mt-auto flex flex-col items-center justify-center">
      <div className="flex items-center justify-center space-x-4 mb-4">
        <SocialLink 
          href="https://instagram.com/yurilobo" 
          icon={<Instagram className="h-5 w-5" />} 
          label="Instagram"
        />
        <SocialLink 
          href="https://tiktok.com/@yurilobo" 
          icon={<TikTokIcon className="h-5 w-5" />} 
          label="TikTok"
        />
        <SocialLink 
          href="https://twitter.com/yurilobo" 
          icon={<Twitter className="h-5 w-5" />} 
          label="Twitter"
        />
        <SocialLink 
          href="https://linkedin.com/in/yurilobo" 
          icon={<Linkedin className="h-5 w-5" />} 
          label="LinkedIn"
        />
      </div>
      <p className="text-xs text-muted-foreground">
        © {currentYear} Yuri Lobo. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
